<nav *ngIf="fleet" class="breadcrumb">
	<a class="breadcrumb-item" [routerLink]="['../../../']">My {{brand.fleetPlural}}</a>
	<span class="breadcrumb-item active">{{fleet?.fleet_name}}</span>
</nav>
<div *ngIf="fleet">
	<div class="item-panel corner">
		<div class="heading">{{brand.fleetSingular}} Overview</div>
		<div class="content">
			<div class="row border-between">
				<div class="col-sm-6 col-md-4">
					<div><b>{{brand.fleetSingular}}:</b> {{fleet.fleet_name}}</div>
					<div><b>Number of {{brand.assetPlural}}:</b> {{fleet.assets.length}}</div>
					<div>
						<b>Remaining Useful Life: </b>
						<span *ngIf="fleet.rulmin">{{fleet.rulmin | number : "1.2-2"}} hrs</span>
						<span *ngIf="!fleet.rulmin">No problems detected</span>
					</div>
				</div>
				<div class="col-sm-6 col-md-4">
					<div class="overall-indicator">
						<div>Overall {{brand.fleetSingular}} Overview</div>
						<app-health-split-fleet [fleet]="fleet"></app-health-split-fleet>
					</div>
				</div>
				<div class="col-md-4 d-none d-md-block">
					<div><b>Sort:</b></div>
					<select class="form-control m-t-3" [ngModel]="sortType" (ngModelChange)="sortChange($event)">
						<option value="tail">{{brand.assetName}}</option>
						<option value="type">{{brand.assetSingular}} Type</option>
						<option value="health">Health Overview</option>
					</select>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg">
			<app-asset-summary [asset]="asset" [time_offset_hours]="fleet.time_offset_hours" (mouseenter)="assetHover(asset)" (mouseleave)="assetUnHover(asset)" *ngFor="let asset of sortedAssets"></app-asset-summary>
		</div>
		<div *ngIf="!allFixed && !(markers && !markers.length)" class="col-lg">
			<div class="item-panel">
				<div class="heading">Last known asset positions</div>
				<div class="content">
					<div *ngIf="!markers" class="loader">
						<div class="logo-spin light"></div>
						Loading...
					</div>
					<google-map *ngIf="markers && markers.length" #googleMap width="100%" height="400px" [options]="mapOptions" (idle)="mapLoaded()">
						<map-marker *ngFor="let marker of markers" (mapClick)="markerClick(marker.mapPoint)" (mapMouseover)="markerMouseover($event, marker)" (mapMouseout)="markerMouseout($event, marker)" [position]="marker.mapPoint" [options]="marker.markerOptions" [assetId]="marker.mapPoint.asset_id"></map-marker>
					</google-map>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="fleet === undefined" class="text-center pt-3 pb-5">
	<div class="logo-spin light"></div>
	Loading fleet...
</div>